<generic-search-results
        [showHeader]="false"
        [showCounter]="false"
        [title]="''"
        [records]="usersDeleted"
        [displayedColumns]="userColumns"
        [selectableRecords]="false"
        [allowLocalFilter]="false"
    ></generic-search-results>